import React from 'react';
import { Typography, Switch, FormControlLabel } from '@mui/material';
import { FormikProps, useFormikContext } from 'formik';
import { useSelector } from 'react-redux';
import { rockySwitcherStyles } from '@styles/rockySwitcherStyles';
import { EvalFilterFields } from '../../enums/EvalFilterFields';
import { EvalFiltersFields } from '../../interfaces/EvalFiltersFields';
import { useEvalHandlers } from '../../hooks/useEvalHandlers';
import { DepartmentData } from '@shared/interfaces/DepartmentData';
import { LocationOptionData } from '@shared/interfaces/LocationOptionData';
import { userProfileOfficeCountrySelector } from '@modules/App/pages/UserProfilePage/redux/selectors';
import { getEvaluationTerms } from '@shared/helpers/evaluationTerminology';

interface Props {
  departments: DepartmentData[];
  locations: LocationOptionData[];
}

export const EvalTypeToggles: React.FC<Props> = ({ departments, locations }) => {
  const rockySwitcher = rockySwitcherStyles();
  const formik: FormikProps<EvalFiltersFields> = useFormikContext();
  const officeCountry = useSelector(userProfileOfficeCountrySelector);
  const evaluationTerms = getEvaluationTerms(officeCountry);
  const { handleIncludeRegularChange, handleIncludeEopChange } = useEvalHandlers(departments, locations);

  return (
    <>
      <FormControlLabel
        sx={{ mr: 2, ml: 0, gap: 0.5 }}
        control={
          <Switch
            className={rockySwitcher.switcher}
            checked={formik.values.includeRegular}
            onChange={(e) => handleIncludeRegularChange(EvalFilterFields.IncludeRegular, e.target.checked)}
            disableRipple
          />
        }
        label={<Typography variant="subtitle1">Regular</Typography>}
      />
      <FormControlLabel
        sx={{ mr: 2, ml: 0, gap: 0.5 }}
        control={
          <Switch
            className={rockySwitcher.switcher}
            checked={formik.values.includeEop}
            onChange={(e) => handleIncludeEopChange(EvalFilterFields.IncludeEop, e.target.checked)}
            disableRipple
          />
        }
        label={<Typography variant="subtitle1">{evaluationTerms.endOfPeriod}</Typography>}
      />
    </>
  );
};
